<template>
    <HeroSectionPage page_title="Email Sent"/>
    <div class="heading4">
        Thank you!
        <br> Your Email has been sent successfully.</div>
</template>
<script>
import HeroSectionPage from '@/components/HeroSectionPage.vue';
export default{
    components:{
       HeroSectionPage 
    }
}
</script>
<style scoped>
.heading4{
    text-align: center;
    color:var(--blue);
    margin-top: 1.5rem;
}
</style>
